<section class="about">
  <div class="container position-relative">
    <p class="font-16 font-sm-20 text-capitalize desc">
      {{ 'about.subtitle' | translate }}
    </p>

    <!-- Action Cards -->
    <div class="card-grid">
      <div *ngFor="let card of actionCards" class="card">
        <h3>{{ card.title | translate }}</h3>
        <p class="">{{ card.description | translate }}</p>
        <div class="card-buttons">
          <button [ngClass]="{'inActive':!card.isActive}"  (click)="handleBtnClick(card.rediretLink)" *ngFor="let button of card.buttons" class="action-button">
            <span *ngIf="card.isActive">{{ button | translate }}</span>
            <span *ngIf="!card.isActive" class="text">{{ button | translate }}</span>
            <span  *ngIf="!card.isActive" class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Stat Cards desktop -->
    <!-- <div class="stats-grid">
      <div *ngFor="let stat of stats; let i = index" class="stat-card">
        <div class="wrap">
          <h3>{{ stat.value | translate }}</h3>
          <p class="m-0 pt-2">{{ stat.label | translate }}</p>
        </div>

        <div [ngClass]="{
            'd-sm-flex align-items-center justify-content-between px-2': true,
            'd-flex': i === 2,
            'd-block': i !== 2,
          }">
          <p class="m-0 ">{{ stat.updated | translate }}</p>
          <a href="#" class="text-decoration-underline text-white font-15">{{ 'about.source' | translate }}</a>
        </div>
      </div>
    </div> -->

    <div class="image-container">
      <img *ngFor="let image of imagePaths; let i = index" [src]="image" alt="" class="img-fluid"
        [ngClass]="{ 'last-img': i === imagePaths.length - 1 }" />
    </div>

    <div class="brokenChain">
      <img src="/assets/images/svg-icons/broken_chains.gif" alt="broken chains" />
    </div>
  </div>
</section>